import styled from 'styled-components'

const TwoStepPaymentFormStepUi = styled.div`
  padding: 15px;
`

export default TwoStepPaymentFormStepUi
